module.exports = __webpack_public_path__ + "static/co_founder_bottom-0d7a825c84d285a3e0bd9e84474d7813.png";